import { render } from "./ProductDetil.vue?vue&type=template&id=c3c79734&scoped=true"
import script from "./ProductDetil.vue?vue&type=script&lang=js"
export * from "./ProductDetil.vue?vue&type=script&lang=js"

import "./ProductDetil.vue?vue&type=style&index=0&id=c3c79734&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/prodbqwjw/sy-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3c79734"]])

export default __exports__